import { date_format, fallbackTz } from '@shared/constants';
import dayjs, { Dayjs } from 'dayjs';

// transform passed date to passed format with fallback
export const transformDateFormat = (
  date: string | Dayjs,
  format: string = date_format,
  emptyValue: string = '',
  timezone: string | null | undefined = fallbackTz
): string => {
  try {
    const formattedDate = dayjs(date)
      .tz(timezone as string)
      .format(format);
    return formattedDate || emptyValue;
  } catch (error) {
    console.error(error);
    return emptyValue;
  }
};

export const getDateRange = (dateOption: string) => {
  const now = dayjs();
  switch (dateOption) {
    case 'last-24-hours':
      return { from: now.clone().subtract(1, 'days'), to: now };
    case 'last-7-days':
      return { from: now.clone().subtract(7, 'days'), to: now };
    case 'last-30-days':
      return { from: now.clone().subtract(30, 'days'), to: now };
    case 'last-3-months':
      return { from: now.clone().subtract(3, 'months'), to: now };
    case 'last-12-months':
      return { from: now.clone().subtract(12, 'months'), to: now };
    case 'last-24-months':
      return { from: now.clone().subtract(24, 'months'), to: now };
    default:
      return { from: now.clone().subtract(3, 'months'), to: now };
  }
};

export const disableFutureDates = (current: Dayjs) => current && current > dayjs().endOf('day');

export const validateDateRangeLimit = (dates: [Dayjs | null, Dayjs | null], limit: number = 90) => {
  const diffInDays = dates?.[1]?.diff(dates?.[0], 'day');
  if (diffInDays && diffInDays > limit) return `Maximum range allowed is ${limit} days.`;
  return '';
};

export const getSecondsDifference = (date: string) => (date ? dayjs().diff(date, 'second') : 0);

export const formatDateWithOrdinal = (date?: string | Date | Dayjs | null): string => {
  if (!date) return '';
  const parsed = dayjs(date);
  if (!parsed.isValid()) return '';
  const day = parsed.date();
  const suffix = day >= 11 && day <= 13 ? 'th' : ['th', 'st', 'nd', 'rd', 'th'][Math.min(day % 10, 4)];
  return `${parsed.format('MMMM')} ${day}${suffix}, ${parsed.format('YYYY')}`;
};
